import { Component, OnInit, Input, Output } from '@angular/core';
import { Imagen } from '../../model/imagen';
import { SubirImagenesService } from '../../services/subir-imagenes.service';

@Component({
  selector: 'app-documento-galeria',
  templateUrl: './documento-galeria.component.html',
  styleUrls: ['./documento-galeria.component.css']
})
export class DocumentoGaleriaComponent implements OnInit {


  public codigoDocumento: string;
  public tipoDocumento: string;

  public imagenes: Imagen[];
  public pdfs: Imagen[];
  public obj :any;

  constructor(
    private _subirImagen: SubirImagenesService
  ) { }

  ngOnInit() {
    var imagen: Imagen = new Imagen();
    var pdf: Imagen = new Imagen();
  }

   public  cargarImagenesDocumento(documento: string, tipoDocumento: string) {

    this.codigoDocumento = documento;
    this.tipoDocumento = tipoDocumento;

    var query: any;

    query = { "codigoDocumento": documento };

    this._subirImagen.getImagenes(query).subscribe(
      data => {
        this.pdfs = [];
        this.imagenes = [];
        for(var i = 0; i < data.length; i++){   
          this.obj = data[i];
          var patt = new RegExp("pdf");
          if(patt.test(this.obj.ruta)){
                this.pdfs.push(data[i]);
            }else{
                this.imagenes.push(data[i]);
            }
        }
                
      },
      err => {
        console.log(err._body);
      });

  }

  public VerPDF(pdf: any){
      window.open(pdf.ruta);
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-galeria/documento-galeria.component.ts